export default __webpack_public_path__ + "static/media/image-skeleton-2000x3000-png.c6eeaae7.png";